


























































































































import NextButton from '@/components/shared/NextButton'
import PreviousButton from '@/components/shared/PreviousButton'
import CancelButton from '@/components/shared/CancelButton'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { Box, MachineSettings, ProgramSettings, RobotTypeEnum } from '@/model/index'
import Units from '@/api/utils/units'
import { isRI20 } from '@/libs/pattern/gripperUtils'
import { defaultMaxBoxLength2Section, defaultMaxBoxLengthInline3 } from '@/api/const'
import { isBoxLongSideLeadingOnly } from '@/libs/pattern/boxUtils'

@Component({
  components: {
    NextButton: NextButton,
    PreviousButton: PreviousButton,
    CancelButton: CancelButton
  }
})
export default class SimpleFormB extends Vue {
  @Prop({ required: true }) private value!: Box
  @Prop({ required: true }) private parentBus!: Vue
  @Prop({ required: true }) private programSettings!: ProgramSettings
  @Prop({ required: true }) private machineSettings!: MachineSettings
  @Prop({ required: true }) private units!: Units
  @Prop({ required: true }) private patternHasBoxPositions!: boolean

  private box: Box = JSON.parse(JSON.stringify(this.value))
  private unitBox: Box = JSON.parse(JSON.stringify(this.value))
  private valid: boolean = false
  // length and width fields shall not be editable if there are layer patterns with box positions
  private lengthAndWidthReadOnly: boolean = this.patternHasBoxPositions
  private isLongSideLeadingOnly: boolean = false
  private rules: object = {
    required: (v: any) => !!v || this.localText('general.required'),
    min: (v: any) => ((!v) || (v > 0)) || this.localText('general.largerEqualZero'),
    width:  (v: any) => (v <= ((this.unitBox && this.unitBox.length) ? this.unitBox.length : 10000)) || this.localText('boxStep.widthErr'),
    length: (v: any) => (v >= ((this.unitBox && this.unitBox.width) ? this.unitBox.width : 0)) || this.localText('boxStep.lengthErr')
  }

  get form (): any {
    return this.$refs.form as any
  }

  /**
   * RULES
   */
  checkBoxLength (v: number) {
    if (this.box.ignoreBoxLimitations) {
      return true
    }
    const boxValidation = this.validBoxInputs()
    const max = this.units.toLocalLength(boxValidation.max.length)
    const min = this.units.toLocalLength(boxValidation.min.length)
    const hasGap = boxValidation.gap && boxValidation.gap.length.length > 0
    const minGap = (hasGap) ? this.units.toLocalLength(boxValidation.gap.length[0]) : null
    const maxGap = (hasGap) ? this.units.toLocalLength(boxValidation.gap.length[1]) : null

    if (v < min! || v > max!
      || (hasGap && (v >= minGap! && v <= maxGap!))) {
      const lengthRange = (hasGap) ? `${ min } - ${ minGap! - 1 }, ${ maxGap! + 1 } - ${ max }` : `${ min } - ${ max }`
      return `${ this.localText ('boxStep.errVal') } ${ lengthRange } ${ this.units.localLengthUnit }`
    }
    return true
  }

  checkBoxWidth (v: number) {
    if (this.box.ignoreBoxLimitations) { // && !isBoxLongSideLeadingOnly(this.unitBox.length!, this.machineSettings)) {
      return true
    }
    const max = this.units.toLocalLength((this.validBoxInputs()).max.width)
    const min = this.units.toLocalLength((this.validBoxInputs()).min.width)
    if (v < min! || v > max!) {
      return `${this.localText('boxStep.errVal')} ${min} - ${max} ${this.units.localLengthUnit}`
    }
    return true
  }

  checkBoxHeight (v: number) {
    if (this.box.ignoreBoxLimitations) {
      return true
    }
    const max = this.units.toLocalLength(this.validBoxInputs().max.height)
    const min = this.units.toLocalLength(this.validBoxInputs().min.height)
    if (v < min! || v > max!) {
      return `${this.localText('boxStep.errVal')} ${min} - ${max} ${this.units.localLengthUnit}`
    }
    return true
  }

  checkBoxWeight (v: number) {
    if (this.box.ignoreBoxLimitations) {
      return true
    }
    const max = this.units.toLocalWeight(this.validBoxInputs().max.weight)
    const min = this.units.toLocalWeight(this.validBoxInputs().min.weight)
    if (v < min! || v > max!) {
      return `${this.localText('boxStep.errVal')} ${min} - ${max}  ${this.units.localWeightUnit}`
    }
    return true
  }

  private validBoxInputs (): any {
    if (this.programSettings.robotType === RobotTypeEnum.RC10_UR) {
      return {
        min: {
          length: 100,
          width: 100,
          height: 100,
          weight: 0
        },
        max: {
          length: 600,
          width: 400,
          height: 500,
          weight: 8200
        }
      }
    } else if (isRI20(this.programSettings.robotType!) && this.machineSettings.gripperSettings) {
      if (this.machineSettings.gripperSettings.gripperSections === 4) {
        const gapValues = (this.unitBox.height! < 140) ? [185, 214] : []
        return {
          min: {
            length: 110,
            width: 105,
            height: 90,
            weight: 0
          },
          max: {
            length: 360,
            width: 200,
            height: 480,
            weight: 4000
          },
          gap: {
            length: gapValues
          }
        }
      } else if (this.machineSettings.gripperSettings.gripperSections === 3) {
        const boxIsLongSideLeadingOnly = isBoxLongSideLeadingOnly (this.unitBox.length!, this.machineSettings)
        const minLength = boxIsLongSideLeadingOnly ? 100 : 110
        const maxLength = boxIsLongSideLeadingOnly ? 400 : defaultMaxBoxLengthInline3
        const maxWidth = boxIsLongSideLeadingOnly ? defaultMaxBoxLengthInline3 : 400
        const minWidth = boxIsLongSideLeadingOnly ? 110 : 100
        return {
            min: {
              length: minLength,
              width: minWidth,
              height: 90,
              weight: 0
            },
            max: {
              length: maxLength,
              width: maxWidth,
              height: 480,
              weight: 15000
            }
          }
      } else if (this.machineSettings.gripperSettings.gripperSections === 2) {
        const boxIsLongSideLeadingOnly = isBoxLongSideLeadingOnly (this.unitBox.length!, this.machineSettings)
        const minLength = boxIsLongSideLeadingOnly ? 210 : 200
        const maxLength = boxIsLongSideLeadingOnly ? 480 : defaultMaxBoxLength2Section
        const maxWidth = boxIsLongSideLeadingOnly ? defaultMaxBoxLength2Section : 480
        const minWidth = boxIsLongSideLeadingOnly ? 200 : 210
        return {
          min: {
            length: minLength,
            width: minWidth,
            height: 110,
            weight: 0
          },
          max: {
            length: maxLength,
            width: maxWidth,
            height: 480,
            weight: 7000
          }
        }
      } else if (this.machineSettings.gripperSettings.gripperSections === 1) {
        return {
          min: {
            length: 200,
            width: 140,
            height: 110,
            weight: 0
          },
          max: {
            length: 600,
            width: 480,
            height: 480,
            weight: 15000
          }
        }
      }
    } else if (this.programSettings.robotType === RobotTypeEnum.RC12 || this.programSettings.robotType === RobotTypeEnum.RC20) {
      return {
        min: {
          length: 150,
          width: 150,
          height: 100,
          weight: 500
        },
        max: {
          length: 600,
          width: 400,
          height: 500,
          weight: 10000
        }
      }
    } else {
      return {
        min: {
          length: 100,
          width: 100,
          height: 100,
          weight: 0
        },
        max: {
          length: 600,
          width: 480,
          height: 480,
          weight: 15000
        }
      }
    }
  }

  private onLengthInput () {
    // when length field is changed, revalidate width field
    Vue.nextTick((this.$refs.widthTextField as any).validate)
    this.isLongSideLeadingOnly = isBoxLongSideLeadingOnly(this.unitBox.length!, this.machineSettings) && !this.box.ignoreBoxLimitations
  }

  private onWidthInput () {
    // when width field is changed, revalidate length field
    Vue.nextTick((this.$refs.lengthTextField as any).validate)
  }

  private onHeightInput () {
    // when height field is changed, revalidate length field
    Vue.nextTick((this.$refs.lengthTextField as any).validate)
  }

  // Watcher to emit valid state to "next" button in stepper
  @Watch('valid')
  private validWatcher (value: boolean) {
    this.$emit('validate', value)
  }

  @Watch('box.ignoreBoxLimitations')
  private boxLimitationWatcher (value: boolean) {
    this.isLongSideLeadingOnly = isBoxLongSideLeadingOnly(this.unitBox.length!, this.machineSettings) && !this.box.ignoreBoxLimitations
    this.form.validate()
  }

  private mounted () {
    // console.log('Mounted SimpleFormB')
    this.box.ignoreBoxLimitations = this.isCustomSolution() ? true : this.box.ignoreBoxLimitations
    this.parentBus.$on('stepper_next', this.next)
    this.parentBus.$on('stepper_previous', this.previous)
    this.makeUnitBox()
    if (this.unitBox.length || this.unitBox.width || this.unitBox.height || this.unitBox.height) {
      this.form.validate()
    }
    this.isLongSideLeadingOnly = isBoxLongSideLeadingOnly(this.unitBox.length!, this.machineSettings) && !this.box.ignoreBoxLimitations
  }

  private beforeDestroy () {
    this.parentBus.$off('stepper_next', this.next)
    this.parentBus.$off('stepper_previous', this.previous)
  }

  private next () {
    // console.log('[DEBUG] SimpleFormB emitting:', this.box)
    this.makeBox()
    this.$emit('next', this.box)
  }

  private previous () {
    this.$emit('previous')
  }

  private makeUnitBox () {
    this.unitBox.length = this.units.toLocalLength(this.box.length)
    this.unitBox.width = this.units.toLocalLength(this.box.width)
    this.unitBox.height = this.units.toLocalLength(this.box.height)
    this.unitBox.lengthMargin = this.units.toLocalLength(this.box.lengthMargin)
    this.unitBox.widthMargin = this.units.toLocalLength(this.box.widthMargin)
    this.unitBox.weight = this.units.toLocalWeight(this.box.weight)
  }

  private makeBox () {
    this.box.length = this.units.toSystemLength(this.unitBox.length)
    this.box.width = this.units.toSystemLength(this.unitBox.width)
    this.box.height = this.units.toSystemLength(this.unitBox.height)
    this.box.lengthMargin = this.units.toSystemLength(this.unitBox.lengthMargin)
    this.box.widthMargin = this.units.toSystemLength(this.unitBox.widthMargin)
    this.box.weight = this.units.toSystemWeight(this.unitBox.weight)
  }

  private localText (b: string): string {
    return String(this.$t(b))
  }

  private translateUnit (unit: string): string {
    return String(this.$t('general.' + unit))
  }

  private isCustomSolution() {
    return this.programSettings.robotType === RobotTypeEnum.CUSTOM_SOLUTION
  }
}

